export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10018.dbdd33f9.jpg";